import React, { useEffect, useRef } from 'react';

import ToggleBase from '@atlaskit/toggle';

const Toggle = ({ isError, ...rest }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) {
      let item = ref.current.querySelector('div:first-of-type');
      if (item) {
        item.style['background-color'] = isError ? '#FF5630' : null;
        item.style.border = '2px solid transparent';
      }
    }
  });

  return (
    <div ref={ref}>
      <ToggleBase {...rest}/>
    </div>
  );
};

export default Toggle;
